import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../assets/css/auth.css';
import { toast } from 'react-toastify';
import logo from '../../assets/images/logo.png';
import { ResetPasswordApi } from '../../Redux/Auth/Auth_Action';

const CreateNewPassword = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const [state, setState] = useState({
        newPass: undefined,
        ConfirmnewPass: undefined,
        email: undefined,
    });

    const [searchParams, setSearchParams] = useSearchParams();
    let token_url = searchParams.get("token");
    // console.log("urlState", token_url);

    const InputVal = (e) => {
        let { name, value } = e.target;
        setState({ ...state, [name]: value });
    }

    const ResetFunction = (e) => {
        e.preventDefault();
        let data = {
            email: state.email,
            reset_token: token_url,
            password: state.newPass,
            confirm_password: state.ConfirmnewPass,
        }
        if (data.password === data.confirm_password) {
            dispatch((ResetPasswordApi(data)))
                .then((res) => {
                    // console.log(res);
                    toast.success("Password change successfully");
                    setTimeout(() => {
                        navigate("/signin");
                    }, 4000);
                })
                .catch((err) => {
                    console.log(err);
                })
        } else {
            toast.error('Password and confirm password is not matched');
        }
    }

    return (
        <div className='authentication createnewpassword'>
            <div className='auth-box-container'>
                <div className='auth-box'>
                    <form onSubmit={ResetFunction}>
                        <div className='row'>
                            <div className='col-lg-12 pt-3 mb-4 text-center'>
                                <img onClick={() => { navigate('/') }} className='logo-top mt-5 cursor_pointer' src={logo} />
                            </div>
                            <div className='col-lg-12 mt-0 text-center'>
                                <p className='f-mon-bold f-45 mb-3 mt-5 create-new-pass'>Create a New Password</p>
                                <p className='mb-0 f-28 f-mon-reg mb-0 lh-01'>Please create a <span className='f-mon-bold'>New Password</span> </p>
                                <p className='mb-0 f-28 f-mon-reg mb-5'>to continue to sign in</p>
                                <input
                                    onChange={InputVal}
                                    name="email" value={state.email} required
                                    type='email' placeholder='Enter Email Address' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                                <input
                                    onChange={InputVal}
                                    name="newPass" value={state.newPass} required
                                    type='password' placeholder='New Password' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                                <input
                                    onChange={InputVal}
                                    name="ConfirmnewPass" value={state.ConfirmnewPass} required
                                    type='password' placeholder='Re-enter New Password' className="form-control f-16 f-mon-reg mt-3 rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-12 mt-3'>
                                <button type="submit" className='btn btn-light form-control bt-auth'>SUBMIT</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateNewPassword;